import tgaAd from 'tga-ad-sdk'
import { Context, CustomError } from '../index'
import {
  SHOW_TITLE_AD_EVENT_TYPE,
  HIDE_TITLE_AD_EVENT_TYPE,
  SHOW_REWARD_AD_EVENT_TYPE,
  HIDE_REWARD_AD_EVENT_TYPE,
  SHOW_SLOT_AD_EVENT_TYPE,
  HIDE_SLOT_AD_EVENT_TYPE,
  SHOW_BANNER_AD_EVENT_TYPE,
  HIDE_BANNER_AD_EVENT_TYPE,
  RESPONSE_CODE,
  LOGGER_PREFIX
} from '../constants'

export default class Ad {
  private context: Context

  private showAdStartTime: number = new Date().getTime()
  private InterceptAdStartTime = 0

  constructor(context: Context) {
    this.context = context
    const { pm } = context

    if (pm) {
      this.addEventListener()
    }
  }

  public static async init(context: Context): Promise<Ad> {
    await tgaAd.init()
    const ad = new Ad(context)

    console.log(`[${LOGGER_PREFIX}] AD init success`)

    return ad
  }

  private addEventListener(): void {
    const { pm } = this.context

    // 显示片头广告
    pm.on(SHOW_TITLE_AD_EVENT_TYPE, async () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${SHOW_TITLE_AD_EVENT_TYPE}'`
      )
      if (this.canShowAd()) {
        try {
          this.setShowAdStartTime()
          const res = await tgaAd.showTitleAd()
          console.log(`[${LOGGER_PREFIX}] show title ad finished`, res)
          pm.emit(HIDE_TITLE_AD_EVENT_TYPE, {
            code: RESPONSE_CODE.SUCCESS,
            payload: res
          })
        } catch (error) {
          pm.emit(HIDE_TITLE_AD_EVENT_TYPE, {
            code: RESPONSE_CODE.FAIL,
            error
          })
        }
      } else {
        pm.emit(HIDE_TITLE_AD_EVENT_TYPE, {
          code: RESPONSE_CODE.FAIL,
          error: new Error('no ad can play')
        })
      }
    })

    // 显示激励广告
    pm.on(SHOW_REWARD_AD_EVENT_TYPE, async () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${SHOW_REWARD_AD_EVENT_TYPE}'`
      )
      if (this.canShowAd()) {
        try {
          this.setShowAdStartTime()
          const res = await tgaAd.showRewardAd()
          console.log(`[${LOGGER_PREFIX}] show reward ad finished`, res)
          pm.emit(HIDE_REWARD_AD_EVENT_TYPE, {
            code: RESPONSE_CODE.SUCCESS,
            payload: res
          })
        } catch (error) {
          pm.emit(HIDE_REWARD_AD_EVENT_TYPE, {
            code: RESPONSE_CODE.FAIL,
            error
          })
        }
      } else {
        pm.emit(HIDE_REWARD_AD_EVENT_TYPE, {
          code: RESPONSE_CODE.FAIL,
          error: new Error('no ad can play')
        })
      }
    })

    // 显示插屏广告
    pm.on(SHOW_SLOT_AD_EVENT_TYPE, async () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${SHOW_SLOT_AD_EVENT_TYPE}'`
      )
      try {
        if (this.canShowAd()) {
          this.setShowAdStartTime()
          if (this.canInterceptAd()) {
            this.setInterceptAdStartTime()
            const res = await tgaAd.showSlotAd()
            console.log(`[${LOGGER_PREFIX}] show slot ad finished`, res)
            pm.emit(HIDE_SLOT_AD_EVENT_TYPE, {
              code: RESPONSE_CODE.SUCCESS,
              payload: res
            })
          } else {
            pm.emit(HIDE_SLOT_AD_EVENT_TYPE, {
              code: RESPONSE_CODE.SUCCESS,
              payload: {
                type: 3,
                message: 'xxx'
              }
            })
          }
        }
      } catch (error) {
        pm.emit(HIDE_SLOT_AD_EVENT_TYPE, {
          code: RESPONSE_CODE.FAIL,
          error
        })
      }
    })

    // 显示banner广告
    pm.on(SHOW_BANNER_AD_EVENT_TYPE, () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${SHOW_BANNER_AD_EVENT_TYPE}'`
      )
      tgaAd.showBannerAd()
    })

    // 隐藏banner广告
    pm.on(HIDE_BANNER_AD_EVENT_TYPE, () => {
      console.log(
        `[${LOGGER_PREFIX}] receive postmessage event '${HIDE_BANNER_AD_EVENT_TYPE}'`
      )
      tgaAd.hideBannerAd()
    })
  }

  private canShowAd(): boolean {
    const time = new Date().getTime()
    const dis = 5000
    return time - this.showAdStartTime > dis
  }

  private setShowAdStartTime(): void {
    this.showAdStartTime = new Date().getTime()
  }

  private canInterceptAd(): boolean {
    const time = new Date().getTime()
    const dis = 3 * 60 * 1000
    console.log(
      `[${LOGGER_PREFIX}] get time`,
      time,
      'get',
      this.InterceptAdStartTime
    )
    return time - this.InterceptAdStartTime > dis
  }

  // 三分钟之内不播放
  private setInterceptAdStartTime(): void {
    this.InterceptAdStartTime = new Date().getTime()
  }
}
